import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import { TOGGLE_APPLICATION_LOCK } from "../../store/application-actions";
import { mapActions } from "vuex";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
import Err from "@Broker/@Routes/error";
export default defineComponent({
  name: "CopyApplicationModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    locked: {
      type: Boolean,
      default: null
    },
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    }
  },
  computed: {
    message() {
      return this.locked ? this.$t("application.messages.unlockApplicationConfirmation") : this.$t("application.messages.lockApplicationConfirmation");
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [TOGGLE_APPLICATION_LOCK])), {}, {
    async submit() {
      const button = $("#confirmation-toggle-lock-button");
      try {
        button.animateButton().animate("start");
        await this.TOGGLE_APPLICATION_LOCK({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername
        });
        await button.animateButton().animate("finish");
      } catch (error) {
        await button.animateButton().animate("finish", "failed");
        Err.handle(error);
      }
      this.$hideModal();
    }
  })
});